<template>
  <div>
    <div class="card-container">
      <div class="card-title">
        <!-- 终端看板 -->
      </div>
      <div class="card-content">
        <a-row class="panel-container">
          <a-col :span="6" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <div class="type-name">
                  <div>
                    <IconFont
                      type="iconshebeizongshu_huaban1"
                      style="font-size: 45px; margin-right: 10px;"
                    />
                  </div>
                  <div class="text-desc">
                    <div>
                      终端总数
                    </div>
                    <div class="type-num" title="1,983">
                      {{ ListNumber.productTotal }}
                    </div>
                  </div>
                </div>
              </span>
            </a-row>
          </a-col>
          <a-col :span="6" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <div class="type-name">
                  <div>
                    <IconFont
                      type="iconyichangshebei_huaban1"
                      style="font-size: 45px; margin-right: 10px;"
                    />
                  </div>
                  <div class="text-desc">
                    <div>
                      异常终端
                    </div>
                    <div class="type-num" title="78">
                      {{ ListNumber.abnormal }}
                    </div>
                  </div>
                </div>
              </span>
            </a-row>
          </a-col>
          <a-col :span="6" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <div class="type-name">
                  <div>
                    <IconFont
                      type="iconzaixianshebei_huaban1"
                      style="font-size: 45px; margin-right: 10px;"
                    />
                  </div>
                  <div class="text-desc">
                    <div>
                      在线终端
                    </div>
                    <div class="type-num" title="1789">
                      {{ ListNumber.online }}
                    </div>
                  </div>
                </div>
              </span>
            </a-row>
          </a-col>
          <a-col :span="6" class="height-90">
            <a-row
              style="flex-direction: column;" type="flex" align="middle"
              justify="center"
            >
              <span>
                <div class="type-name">
                  <div>
                    <IconFont
                      type="iconguzhangshuai_huaban1"
                      style="font-size: 45px; margin-right: 10px;"
                    />
                  </div>
                  <div class="text-desc">
                    <div>
                      正常设备
                    </div>
                    <div class="type-num" title="20%">
                      {{ ListNumber.failureRate }}
                    </div>
                  </div>
                </div>
              </span>
            </a-row>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="card-container">
      <div
        class="card-title" style="    display: flex;justify-content: space-between;"
      >
        <div>终端筛选</div>
        <div>
          <a-badge
            status="processing" text="在线"
          />
          <a-badge
            status="warning" text="离线"
          />
        </div>
      </div>

      <div class="card-content">
        <a-form ref="detailForm" class="detail-form" :form="form">
          <a-row>
            <a-col class="search-item" :span="6">
              <a-form-item label="区域" v-bind="formItemLayout">
                <a-cascader
                  v-model="region"
                  :options="options"
                  :load-data="loadData"
                  change-on-select
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区、街道"
                  @change="changeArea"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item label="小区" v-bind="formItemLayout">
                <a-select
                  v-decorator="['estateId']"
                  allow-clear
                  show-search
                  placeholder="全部"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item
                label="系统健康状态"
                v-bind="formItemLayout"
              >
                <a-select
                  v-model="state"
                  v-decorator="['state',{initialValue: ''}]"
                  allow-clear
                  placeholder="请选择"
                >
                  <a-select-option value="">
                    全部
                  </a-select-option>
                  <a-select-option value="0">
                    在线
                  </a-select-option>
                  <a-select-option value="1">
                    离线
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6" align="right">
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetForm">
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div
        v-if="total === 0" style="text-align: center;line-height: 60px;font-size: 12px;color: #999;    display: flex;
    justify-content: center;
    align-items: center;"
      >
        <a-icon type="frown" style="font-size: 18px;" />
        <div style="padding-left: 4px;">
          暂无数据~
        </div>
      </div>
    </div>
    <div v-if="loading" style="text-align: center;">
      <a-spin />
    </div>
    <div v-else class="list-container">
      <div
        v-for="(item,index) in dataList" :key="index" :loading="loading" class="card" :class=" item.productState === 0 ? '' : (!item.child || item.child.length === 0) ? 'itemTypes': 'itemType'"
        style="width: 20%;"
      >
        <div class="Before" :class="(item.flag === undefined || item.flag) && item.type === 0 ? 'beforeCard' : ''">
          <a-card
            v-show="item.flag === undefined || item.flag"

            :title="item.name"
            :class="item.type ? 'itemCard' : ''"
            style="width: 95%;margin-top: 15px;"
          >
            <span slot="extra">{{ item.estateName }}</span>

            <div style="height: 270px;overflow: auto;">
              <a-row>
                <a-col v-for=" (items,id) in item.child" :key="id" :span="12">
                  <div>
                    <div>
                      {{ items.scenario | titleFilter }}
                    </div>
                    <div>
                      <img style="width:40px;height:40px" :src="items.scenario | titleFileImg">
                    </div>
                    <div style="display:flex">
                      <div v-if="items.state === 0">
                        <!-- <span class="port normal"></span>
                        <span class="text">正常</span> -->
                      </div>
                      <div v-if="items.state === 1" style="    background: red;color: #fff;border-radius: 2px;    position: absolute;left: 33px;    top: 44px;    padding: 0 3px;">
                        <!-- <span class="port abnormal"></span> -->
                        <span class="" style="font-size:12px">设备异常</span>
                      </div>
                    </div>
                  </div>
                  <div class="dotted"></div>
                </a-col>
                <a-col v-if="!item.child || item.child.length === 0" style="padding-top:60px">
                  <a-empty />
                </a-col>
              </a-row>
            </div>
            <!-- <div v-if="item.state === 1" style="text-align:center">
              <a-button type="danger" @click="handleBefore(item,index)">
                查看详情
              </a-button>
            </div> -->
          </a-card>
        </div>

        <!-- <div class="After" :class="item.flag !== undefined && !item.flag ? 'afterCard' : ''">
          <a-card
            v-show="item.flag !== undefined && !item.flag"
            :title="item.scenario === 1?'垃圾庭':item.scenario === 2 ? '回收站':'垃圾房'"
            :class="item.type ? 'itemCard' : ''"
            style="width: 95%;margin-top: 15px;"
          >
            <span slot="extra">{{ item.estateName }}</span>
            <div style="height: 260px;overflow: auto;">
              <div v-for="(beforeItem,beforeIndex) in item.detail" :key="beforeIndex">
                <div>
                  {{ beforeItem.typeName }}
                </div>
                <div v-for="(items,id) in beforeItem.detail" :key="id">
                  <span class="port abnormal"></span>
                  <span style="margin-left:7px">{{ items.deliverySerial }}</span>
                  <span v-if="items.state === 0" style="margin-left:7px">正常</span>
                  <span v-if="items.state === 1" style="margin-left:7px">故障</span>
                </div>
                <div v-if="beforeIndex < (item.detail.length - 1)" class="dotted"></div>
              </div>
            </div>
            <div v-show="!item.type" style="text-align:center;margin-top:10px;">
              <a-button type="danger" @click="handleBefore(item,index)">
                返回
              </a-button>
            </div>
          </a-card>
        </div> -->
      </div>
    </div>

    <div
      v-if="noData"
      class="footer"
    >
      <span>
        {{ '共' + total + '条记录' }}
      </span>
      <a-pagination
        v-model="current"
        show-size-changer
        :page-size.sync="pageSize"
        :total="total"
        @change="handleTableChange"
        @showSizeChange="onShowSizeChange"
      />
    </div>
  </div>
</template>

<script>
import {
  getArea,
  getEstate,
  iconFontComponent
} from '@/components/mixins/mixins.js'
import { getDashboard, getHealthyList, getyHealthyDetail, getHealthyCount } from '@/api/deviceOrder'

export default {
  filters: {
    titleFileImg: function (value) {
      switch (value) {
        case 1:
          return 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211129/1638168628356c3d37f951a7f401890ab589ccae85da0.png'
        case 2:
          return 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211129/16381686567218a8766c8f171448b9aafd51278f21302.png'
        case 3:
          return 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211129/1638168684364f3ab7895e5674fb184e7dbbf0ebd88e9.png'
        case 4:
          return 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211129/16381687054395a224ba19b32470186acc52081920489.png'
        case 5:
          return 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211129/16381687256835109d244cfd14753bdbea351dd5e13f2.png'
        case 6:
          return 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211129/16381687421096db222e94a214a08a085c4c1ed301534.png'
        case 7:
          return 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211129/1638168761110b1362ab1ae0e497ea84d0a87b2996acd.png'
        case 8:
          return 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211129/1638168785433b0ddd66c8d9c452fae45cf0e3b45b705.png'
        case 9:
          return 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20211129/16381688046274dfbba5251814b9b90abaeccec69dd1e.png'
        default:
          return '字段值异常，请检查后台数据'
      }
    },
    titleFilter: function (value) {
      switch (value) {
        case 1:
          return '环境精灵'
        case 2:
          return '内部灯'
        case 3:
          return '外部灯'
        case 4:
          return '水阀'
        case 5:
          return '投递系统'
        case 6:
          return '灭蚊灯'
        case 7:
          return '空调'
        case 8:
          return '出丑精灵'
        case 9:
          return 'LED'
        default:
          return '字段值异常，请检查后台数据'
      }
    }
  },
  mixins: [getArea, getEstate, iconFontComponent],
  data () {
    return {
      form: this.$form.createForm(this, {}),
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      state: '',
      loading: false,
      current: 1,
      pageSize: 10,
      total: 0,
      region: [],
      dataList: [
        {
          type: 0,
          equipmentType: '智能回收站',
          plot: '东秦新苑',
          mouth: 1,
          door: 0,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 0,
          flag: true,
          detials: [
            {
              text: '通断场景',
              desc: ['空调插座 故障', '水阀通断器 故障']
            },
            {
              text: '环境精灵',
              desc: ['硫化氢 故障']
            },
            {
              text: '除臭精灵',
              desc: ['氨气设备 故障']
            },
            {
              text: '摄像头',
              desc: ['内部摄像头 故障']
            }
          ]
        },
        {
          type: 0,
          equipmentType: '智能回收站',
          plot: '东秦新苑',
          mouth: 1,
          door: 0,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 0,
          flag: true,
          detials: [
            {
              text: '通断场景',
              desc: ['空调插座 故障', '水阀通断器 故障']
            },
            {
              text: '环境精灵',
              desc: ['硫化氢 故障']
            },
            {
              text: '除臭精灵',
              desc: ['氨气设备 故障']
            },
            {
              text: '摄像头',
              desc: ['内部摄像头 故障']
            }
          ]
        },
        {
          type: 0,
          equipmentType: '智能垃圾箱',
          plot: '清水湾花园',
          mouth: 1,
          door: 0,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 0,
          flag: true,
          detials: [
            {
              text: '通断场景',
              desc: ['空调插座 故障', '水阀通断器 故障']
            },
            {
              text: '环境精灵',
              desc: ['温湿度设备 故障', 'VOC设备 故障']
            }
          ]
        }, {
          type: 0,
          equipmentType: '智能回收站',
          plot: '东秦新苑',
          mouth: 1,
          door: 0,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 0,
          flag: true,
          detials: [
            {
              text: '通断场景',
              desc: ['空调插座 故障', '水阀通断器 故障']
            },
            {
              text: '环境精灵',
              desc: ['硫化氢 故障']
            },
            {
              text: '除臭精灵',
              desc: ['氨气设备 故障']
            },
            {
              text: '摄像头',
              desc: ['内部摄像头 故障']
            }
          ]
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '清水湾花园',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '清水湾花园',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '东秦新苑',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '东秦新苑',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '东秦新苑',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1
        }, {
          type: 1,
          equipmentType: '智能垃圾箱',
          plot: '东秦新苑',
          mouth: 1,
          door: 1,
          ExternalLight: 1,
          innerLight: 1,
          lamp: 1
        }
      ],
      isTop: false,
      ListNumber: {},
      turnOver: [],
      state: '',
      noData: false
    }
  },
  mounted: function () {
    this.load()
    this.getHealthyCount()
  },
  methods: {
    handleBefore (item, index) {
      this.getyHealthyDetail(item.id)
      item.flag = !item.flag
      const element = document.getElementsByClassName('card')[index]
      if (element.style.transform === 'rotateY(180deg)') {
        element.style.transform = 'rotateY(0deg)'
      } else {
        element.style.transform = 'rotateY(180deg)'
      }
    },
    load () {
      this.getArea('', 2)
      this.getEstate()
      this.total = 10
      // this.getDashboard()
      this.getProductList()
    },
    getDashboard () {
      const params = {}
      getDashboard(params).then(res => {
        // console.log(res)
      })
    },
    // 数量
    getHealthyCount () {
      const params = {
        type: 2
      }
      getHealthyCount(params).then(res => {
        this.ListNumber = res.result
        // console.log(res, '数量')
      })
    },
    getProductList () {
      const params = {
        page: this.current,
        pageSize: this.pageSize,
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        estateId: this.form.getFieldValue('estateId'),
        type: 2,
        state: this.state
      }
      params.streetId = this.region[3] || ''
      this.noData = false
      this.loading = true
      getHealthyList(params).then(res => {
        if (res.result.list.length > 0) {
          this.noData = true
        }
        const result = res.result

        this.loading = false
        result.list.forEach(val => {
          val.flag = true
          return {
            ...val,
            flag: true
          }
        })
        this.dataList = result.list

        this.total = result.totalCount
      })
    },

    // 列表详情
    getyHealthyDetail (val) {
      const parmes = {
        id: val
      }
      getyHealthyDetail(parmes).then(res => {
        this.turnOver = res.result
      })
    },

    changeArea (areasId) {
      this.estateList = []
      this.form.setFieldsValue({ estateId: undefined })
      if (areasId.length < 4) {
        this.getEstate(areasId)
      } else if (areasId.length === 4) {
        this.getEstate(null, areasId[3])
      }
    },
    toSearch () {
      this.current = 1
      const params = {
        page: this.current,
        pageSize: this.pageSize,
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        estateId: this.form.getFieldValue('estateId'),
        type: 2,
        state: this.state
      }
      params.streetId = this.region[3] || ''
      this.loading = true

      getHealthyList(params).then((res, index) => {
        // const element = document.getElementsByClassName('card')[index]
        // element.style.transform = 'rotateY(0deg)'
        const result = res.result
        this.loading = false
        result.list.forEach(val => {
          val.flag = true
          return {
            ...val,
            flag: true
          }
        })

        const dataList = result.list
        this.dataList = dataList
        // this.$set(this.dataList, 'self_update', result.list)
        // delete this.dataList.self_update
        this.total = result.totalCount
      })
    },
    resetForm () {
      this.form.resetFields()
      this.region = []
      this.form.setFieldsValue({ estateId: undefined })
      this.getProductList()
      this.getEstate()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onShowSizeChange (current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getProductList()
    },
    handleTableChange (current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getProductList()
    }
  }
}
</script>

<style lang="css" scoped>
  .list-container{
    perspective:2000px;
  }
  .card{
    transition: transform 0.5s;
    transform-style: preserve-3d;
  }
  .After{
    transform: rotateY(180deg);
  }
</style>

<style lang="stylus" scoped>
.footer
  padding 35px 0px
  display flex
  justify-content center
  align-items center
  span
    padding-right 7px
.list-container >>> .ant-card-body
  height 350px
.list-container >>> .ant-btn-danger
  background-color rgba(255, 186, 0, 1)
  border-color rgba(255, 186, 0, 1)
.list-container >>> .ant-card-head
  min-height 0
  background rgba(24, 144, 255, 1)
  color white
  padding 0 20px
  .ant-card-head-title
    font-size 15px
    padding 12px 0
  .ant-card-extra
    color white
    padding 12px 0
.list-container
  width 100%
  display flex
  flex-wrap wrap
  .itemType >>> .ant-card-head
    background rgba(255, 186, 0, 1)
  .itemTypes >>> .ant-card-head
    background #B3B3B3
  .ant-row
    width 95%
    text-align center
  .dotted
    border-bottom 1px dashed #b7b7b7
    margin: 15px 0;
  .port
    width 7px
    height 7px
    border-radius 50%
    display inline-block
  .normal
    background rgba(24, 144, 255, 1)
  .text
    margin-left 7px
    font-size 12px
  .abnormal
    background rgba(255, 186, 0, 1)
.card-container
  .card-title
    span
      font-weight normal
      margin-left 30px
      font-size 15px
.panel-container
  margin-bottom 25px
.height-90
  height 90px
  position relative
  .type-name
    color #666666
    font-size 12px
    margin-top 16px
    display flex
    align-items center
    .text-desc
      display flex
      flex-direction column
      align-items center
      div:nth-child(1)
        font-size 14px
        font-weight 600
  .type-num
    font-size 24px
    color #333333
    margin-top 8px
    text-align left
</style>
